import { render, staticRenderFns } from "./SectionChat.vue?vue&type=template&id=54032188&scoped=true&"
import script from "./SectionChat.vue?vue&type=script&lang=js&"
export * from "./SectionChat.vue?vue&type=script&lang=js&"
import style0 from "./SectionChat.vue?vue&type=style&index=0&id=54032188&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54032188",
  null
  
)

export default component.exports